import { connect } from "react-redux"
import DeviceManager from "./DeviceManager"

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceManager)
